import { zId } from "src/types";
import z from "zod";

import { zClassUnsafe } from "./ZClassRow";

export const zSecondSpecUpdate = z.object({
  schemaId: z.string(),
  linkTypeCode: z.number(),
  catalogIds: z.string().array().optional(),
});
export type ZSecondSpecUpdate = z.infer<typeof zSecondSpecUpdate>;

export const zClassUpdate = zClassUnsafe
  .pick({
    data: true,
  })
  .extend({
    name: z.string(), // Этого не должно быть. Но сейчас без него не работает.
    parentIds: zId.array(),
    secondarySchemas: zSecondSpecUpdate.array(),
  });

export type ZClassUpdate = z.infer<typeof zClassUpdate>;
